import React, { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Users, Settings, LogOut, Menu } from "lucide-react";

const NAV = [
  { to: "/admin/dashboard", label: "Resumen", icon: LayoutDashboard },
  { to: "/admin/pacientes", label: "Pacientes", icon: Users },
  { to: "/admin/configuracion", label: "Configuración", icon: Settings },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const doLogout = async () => { await logout(); navigate("/admin", { replace: true }); };
  const isAdmin = user?.role === "admin";
  const navItems = NAV.filter((n) => isAdmin || n.to !== "/admin/configuracion");

  const SidebarContent = () => (
    <>
      <div className="flex items-center gap-2 px-5 py-4 border-b border-slate-200">
        <img src="/logo-mark.jpg" alt="PROAM" className="h-10 w-auto" />
        <div>
          <p className="font-heading font-bold text-slate-900 leading-tight">PROAM</p>
          <p className="text-xs text-slate-500">Venezuela</p>
        </div>
      </div>
      <nav className="flex-1 px-3 py-4 space-y-1">
        {navItems.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            onClick={() => setOpen(false)}
            data-testid={`nav-${label.toLowerCase()}`}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-3 rounded-lg font-medium transition-colors ${
                isActive ? "bg-orange-50 text-orange-700" : "text-slate-600 hover:bg-slate-50"
              }`
            }
          >
            <Icon className="h-5 w-5" /> {label}
          </NavLink>
        ))}
      </nav>
      <div className="px-3 py-4 border-t border-slate-200">
        <p className="px-3 text-sm text-slate-700 truncate">{user?.name}</p>
        <p className="px-3 text-xs text-slate-400 truncate mb-2">{isAdmin ? "Administrador" : "Solo lectura"}</p>
        <button onClick={doLogout} data-testid="logout-btn" className="w-full flex items-center gap-3 px-3 py-3 rounded-lg text-slate-600 hover:bg-slate-50 font-medium">
          <LogOut className="h-5 w-5" /> Cerrar sesión
        </button>
      </div>
    </>
  );

  return (
    <div className="min-h-screen bg-slate-50 flex">
      <aside className="hidden lg:flex w-64 bg-white border-r border-slate-200 flex-col fixed inset-y-0">
        <SidebarContent />
      </aside>

      {open && (
        <div className="lg:hidden fixed inset-0 z-40">
          <div className="absolute inset-0 bg-black/40" onClick={() => setOpen(false)} />
          <aside className="absolute inset-y-0 left-0 w-64 bg-white flex flex-col"><SidebarContent /></aside>
        </div>
      )}

      <div className="flex-1 lg:ml-64 min-w-0">
        <header className="lg:hidden sticky top-0 z-30 bg-white border-b border-slate-200 flex items-center justify-between px-4 py-3">
          <button onClick={() => setOpen(true)} data-testid="menu-toggle"><Menu className="h-6 w-6 text-slate-700" /></button>
          <span className="font-heading font-bold text-slate-900">PROAM Venezuela</span>
          <span className="w-6" />
        </header>
        <main className="p-5 lg:p-8 max-w-7xl mx-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
